import { Component, OnInit } from '@angular/core';
import { FirestoreService } from 'src/app/core/services/firestore.service';
import { Observable } from 'rxjs';
import { combineLatest, map, combineAll } from 'rxjs/operators';
import { Illustration } from 'src/app/core/interfaces/illustration';
import { Artwork } from 'src/app/core/interfaces/artwork';
import { Bookplates } from 'src/app/core/interfaces/bookplates';
import { BaseArtWork } from 'src/app/core/interfaces/base-artwork';
import { photos } from 'src/app/core/interfaces/photos';
import { ResponsiveService } from 'src/app/core/services/responsive.service';

@Component({
  selector: 'app-index-picture-carousel',
  templateUrl: './index-picture-carousel.component.html',
  styleUrls: ['./index-picture-carousel.component.scss']
})
export class IndexPictureCarouselComponent  {
  public isMobile: Boolean;
  public isIpad: Boolean;
  public isDesktop: boolean;
  photos: Observable<photos[]>;

  constructor(private firestoreService: FirestoreService, private responsiveService: ResponsiveService) {
/*     this.illustrations = this.firestoreService.getItem<Illustration>('Illustrations');
    this.artwork = this.firestoreService.getItem<Artwork>('artwork');
    this.bookplate = this.firestoreService.getItem<Bookplates>('bookplates'); */
    this.photos = this.firestoreService.getItem<photos>('artwork');

}

ngOnInit(): void {
  this.onResize();
  this.responsiveService.checkWidth();
}
onResize() {
  this.responsiveService.getMobileStatus().subscribe(isMobile => {
    this.isMobile = isMobile;
  });
  this.responsiveService.getIpadStatus().subscribe(isIpad => {
    this.isIpad = isIpad;
  });
  this.responsiveService.getDesktopStatus().subscribe(isDesktop => {
    this.isDesktop = isDesktop;
  });
}
}